import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { IShareholderSummaryInfo } from '@appShared/interfaces/[Model-based]/shareholder-summary-info.interface';
import { State } from '@appState/reducers';
import * as fromStore from '@appState/selectors/shareholder.selectors';
import {
  ShareholderApiActions,
  ShareholderPageActions
} from '@appState/actions/shareholder';

@Injectable({
  providedIn: 'root'
})
export class ShareholderFacade {
  shareholders$: Observable<IShareholderSummaryInfo[]> = this._store.select(
    fromStore.getShareholders
  );

  shareholderSearchFilter$: Observable<string> = this._store.select(
    fromStore.getShareholderSearchFilter
  );

  filteredShareholders$: Observable<
    IShareholderSummaryInfo[]
  > = this._store.select(fromStore.getFilteredShareholders$);

  constructor(private _store: Store<State>) {}

  loadShareholders(includeRepurchaseOptionExecuted?: boolean): void {
    this._store.dispatch(
      ShareholderPageActions.loadShareholders({ includeRepurchaseOptionExecuted: includeRepurchaseOptionExecuted ?? false })
    );
  }

  /* for use with "reload" if admin goes "home" and back to "admin" */
  setShareholders(shareholders: IShareholderSummaryInfo[]): void {
    this._store.dispatch(
      ShareholderApiActions.loadShareholdersSuccess({ shareholders })
    );
  }

  setShareholderSearchFilter(searchFilter?: string): void {
    this._store.dispatch(
      ShareholderPageActions.setShareholderSearchFilter({
        searchFilter
      })
    );
  }

  prefetchShareholders(shareholders: IShareholderSummaryInfo[]): void {
    // if haven't gotten store yet, go get it
    if (!shareholders) {
      this.loadShareholders();
    }
  }
}
